import { c as _c } from "react/compiler-runtime";
import Router, { useRouter } from 'next/router';
import { useEffect } from 'react';
import { type PagePermissions, usePermission } from 'shared/hooks/use-permission';
import { pageRoute } from 'shared/constants/routes.constants';
const hasPagePermission = (pagePermissions: PagePermissions, pathname: string): pathname is keyof PagePermissions => Object.hasOwn(pagePermissions, pathname);
export const useGuard = () => {
  const $ = _c(6);
  const router = useRouter();
  const {
    isReady,
    pagePermissions
  } = usePermission();
  const {
    isReady: isRouterReady,
    pathname
  } = router;
  let t0;
  let t1;
  if ($[0] !== isReady || $[1] !== isRouterReady || $[2] !== pagePermissions || $[3] !== pathname) {
    t0 = () => {
      if (!isRouterReady || !isReady) {
        return;
      }
      if (!hasPagePermission(pagePermissions, pathname)) {
        return;
      }
      if (pagePermissions[pathname]) {
        return;
      }
      Router.replace(pageRoute.NotFound);
    };
    t1 = [isReady, isRouterReady, pagePermissions, pathname];
    $[0] = isReady;
    $[1] = isRouterReady;
    $[2] = pagePermissions;
    $[3] = pathname;
    $[4] = t0;
    $[5] = t1;
  } else {
    t0 = $[4];
    t1 = $[5];
  }
  useEffect(t0, t1);
};